const apiServer = process.env.VUE_APP_APIHOST;
const gisServer = process.env.VUE_APP_LIDAR_MAP_URL;
const mapApiKey = "dbdd7d73de0241a99aac87dfd256227a";
const outSR = 102140;
const outFields = "*";
export default {
  apiServer,
  gisServer,
  mapApiKey,
  queryEmailAddress: "admin_svygis@cedd.gov.hk",
  dmAuthDefault: 0,
  urls: {
    getCaptcha: `${apiServer}captcha`,
    validateCaptcha: `${apiServer}captcha/validate`,
    validateCaptchaToken: `${apiServer}project/isAuthorised`,
    validateProjectToken: `${apiServer}order/isAuthorised`,
    validateOrderToken: `${apiServer}completed/isAuthorised`,
    suggest: `${apiServer}project/suggest`,
    projectName: `${apiServer}project/name?contNo=`,
    validateProject: `${apiServer}project/validate`,
    smf0096: `${apiServer}order/smf0096`,
    smf0097: `${apiServer}contract/smf0097`,
    contractsmf0096: `${apiServer}contract/smf0096`,
    uploadCSV: `${apiServer}uploadcsv`,
    submitOrder: `${apiServer}order`,
    orderStatus: `${apiServer}orderStatus`,
    contractStatus: `${apiServer}contract`,
    contractCessation: `${apiServer}contract/cessation`,
    contractExtension: `${apiServer}contract/extension`,
    bypass: `${apiServer}project/bypass`,
    findAddressCandidates: `https://api.hkmapservice.gov.hk/ags/gc/composite/findAddressCandidates?key=${mapApiKey}&f=json&outFields=${outFields}&outSR={"wkid":${outSR}}&`,
    composite: `https://api.hkmapservice.gov.hk/ags/gc/composite/suggest?key=${mapApiKey}&f=json&maxSuggestions=10&`,
    urlBasemap: {
      tiles: `//api.hkmapservice.gov.hk/ags/map/basemap/HK80`,
      tiles_WGS84: `//api.hkmapservice.gov.hk/ags/map/basemap/WGS84`,
      tiles_GS_WGS84: `//api.hkmapservice.gov.hk/ags/map/basemap/GS/WGS84`,
      tiles_SATELLITE_WGS84: `//api.hkmapservice.gov.hk/ags/map/worldimagery/WGS84`,
      vt_tiles: `//api.hkmapservice.gov.hk/ags/map/basemap/VT/HK80`,
      vt_tiles_WGS84: `//api.hkmapservice.gov.hk/ags/map/basemap/VT/WGS84`,
      dop5000: `//api.hkmapservice.gov.hk/ags/map/imagery/HK80`,
      dop5000_1982: `//api.hkmapservice.gov.hk/ags/map/imagery/HK80`,
      dop1000_1963G: `${gisServer}/DOP1000/1963G/ImageServer`,
      dop1000_1963P: `${gisServer}/DOP1000/1963P/ImageServer`,
      dop1000_1982G: `${gisServer}/DOP1000/1982P/ImageServer`,
      dop1000_1982P: `${gisServer}/DOP1000/1982P/ImageServer`,
      annotation_en: `//api.hkmapservice.gov.hk/ags/map/label-en/HK80`,
      annotation_tc: `//api.hkmapservice.gov.hk/ags/map/label-tc/HK80`,
      annotation_sc: `//api.hkmapservice.gov.hk/ags/map/label-sc/HK80`,
      annotation_WGS84_en: `//api.hkmapservice.gov.hk/ags/map/label-en/WGS84`,
      annotation_WGS84_tc: `//api.hkmapservice.gov.hk/ags/map/label-tc/WGS84`,
      annotation_WGS84_sc: `//api.hkmapservice.gov.hk/ags/map/label-sc/WGS84`,
      vt_annotation_en: `//api.hkmapservice.gov.hk/ags/map/label-en/VT/HK80`,
      vt_annotation_tc: `//api.hkmapservice.gov.hk/ags/map/label-tc/VT/HK80`,
      vt_annotation_sc: `//api.hkmapservice.gov.hk/ags/map/label-sc/VT/HK80`,
      vt_annotation_WGS84_en: `//api.hkmapservice.gov.hk/ags/map/label-en/VT/WGS84`,
      vt_annotation_WGS84_tc: `//api.hkmapservice.gov.hk/ags/map/label-tc/VT/WGS84`,
      vt_annotation_WGS84_sc: `//api.hkmapservice.gov.hk/ags/map/label-sc/VT/WGS84`,
      ground: "//api.hkmapservice.gov.hk/ags/image/hkterrain/WGS84",
    },
    iDMOSGISServer: `${gisServer}/iDMOS/MapIndex/MapServer`,
  },
  mapSymbol: {
    pointHighlight: {
      type: "simple-marker",
      size: 8,
      outline: {
        color: "yellow",
        width: 3,
      },
    },
    pointSymbol: {
      type: "simple-marker",
      color: [255, 0, 0, 1],
      size: 8,
    },
    shapeSymbol: {
      type: "simple-fill",
      color: [255, 0, 0, 0.5],
      outline: {
        width: 0,
      },
    },
    shapeOutlinedSymbol: {
      type: "simple-fill",
      color: "transparent",
      outline: {
        color: [255, 0, 0, 0.5],
        width: 2,
      },
    },
    shapeHighlight: {
      type: "simple-fill",
      style: "none",
      outline: {
        color: "yellow",
        width: 2,
      },
    },
  },
  AOIConfig: {
    AOIColor: [255, 0, 0],
    AOIFill: [255, 0, 0, 0.1],
    AOILineWidth: 2,
    AOIPOintColor: [255, 0, 0, 0.7],
  },
};
